/* ============================================================
   AUREN — auren.js · animaciones, carrito real (Shopify AJAX Cart API) y UI.
   Sin dependencias externas. Respeta prefers-reduced-motion.
   ============================================================ */

/* ---------- REVEAL ---------- */
const io = new IntersectionObserver(entries=>{
  entries.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}});
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

const motionOk = !matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- HELPERS UI (scroll-lock, focus-trap, toast) ---------- */
/* Bloqueo de scroll con contador: varios modales pueden abrirse en secuencia
   sin que cerrar uno reactive el scroll mientras otro sigue abierto. */
let scrollLocks = 0;
function lockScroll(){ if(scrollLocks++ === 0) document.body.style.overflow = 'hidden'; }
function unlockScroll(){ if(scrollLocks > 0 && --scrollLocks === 0) document.body.style.overflow = ''; }

/* Atrapa el foco dentro de un contenedor (modal) y lo devuelve al cerrar. */
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
function focusables(container){ return [...container.querySelectorAll(FOCUSABLE)].filter(el=>el.offsetParent !== null); }
function makeTrap(container){
  let prevFocused = null;
  const onKey = e=>{
    if(e.key !== 'Tab') return;
    const f = focusables(container); if(!f.length) return;
    const first = f[0], last = f[f.length-1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  };
  return {
    engage(){
      prevFocused = document.activeElement;
      document.addEventListener('keydown', onKey);
      const f = focusables(container); if(f[0]) f[0].focus();
    },
    release(){
      document.removeEventListener('keydown', onKey);
      if(prevFocused && prevFocused.focus) prevFocused.focus();
      prevFocused = null;
    }
  };
}

/* Toast discreto (sustituye a alert nativo) */
let _toastEl, _toastT;
function toast(msg){
  if(!_toastEl){
    _toastEl = document.createElement('div');
    _toastEl.className = 'auren-toast';
    _toastEl.setAttribute('role','status');
    _toastEl.setAttribute('aria-live','polite');
    document.body.appendChild(_toastEl);
  }
  _toastEl.textContent = msg;
  _toastEl.classList.add('show');
  clearTimeout(_toastT);
  _toastT = setTimeout(()=>_toastEl.classList.remove('show'), 3200);
}

/* ---------- DATOS ---------- */
const COLECCIONES = [
  {clave:"foundation", drop:"Drop 001", nombre:"FOUNDATION", claim:"Built to Dominate", estado:"Disponible", dispo:true,
   piezas:[
     {nombre:"Rashguard FOUNDATION Black", precio:49, img:"front", hover:"back", prod:"rashguard"},
     {nombre:"Shorts FOUNDATION Black",    precio:39, img:"shorts", prod:"shorts"},
   ]},
  {clave:"pantheon", drop:"Drop 002", nombre:"PANTHEON", claim:"Challenge the Gods", estado:"Próximamente", dispo:false,
   piezas:[
     {nombre:"Rashguard PANTHEON"},
     {nombre:"Shorts PANTHEON"},
   ]},
  {clave:"imperium", drop:"Drop 003", nombre:"IMPERIUM", claim:"Built to Conquer", estado:"Próximamente", dispo:false,
   piezas:[
     {nombre:"Rashguard IMPERIUM"},
     {nombre:"Shorts IMPERIUM"},
   ]},
];
/* Las URLs reales se inyectan desde Liquid en auren-home.liquid → window.AUREN_ASSETS
   (asset_url no se puede usar dentro de un .js estático de Shopify). */
const IMGS = (window.AUREN_ASSETS) || {
  front:  "foundation-front.webp",
  back:   "foundation-back.webp",
  shorts: "foundation-shorts.webp"
};
/* Productos reales inyectados desde Liquid (id de variante, talla, precio en céntimos, disponibilidad) */
const PRODUCTS = window.AUREN_PRODUCTS || {};
const fmt = n => n.toLocaleString('es-ES',{style:'currency',currency:'EUR'});
/* Escape HTML: los datos de producto/carrito (títulos, tallas) se inyectan en innerHTML;
   escaparlos evita XSS almacenado si un título/variante llevara markup. */
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
/* Precio real (€) de un producto inyectado; los precios de Shopify llegan en céntimos. */
function precioReal(prodKey, fallback){
  const p = PRODUCTS[prodKey];
  if(p && p.variants && p.variants.length) return p.variants[0].price / 100;
  return fallback;
}

/* ---------- RENDER POR COLECCIONES (filas horizontales) ---------- */
const filas = document.getElementById('coleccionRows');
const MOSTRAR_PROXIMOS = !!window.AUREN_SHOW_UPCOMING;
if (filas) {
COLECCIONES.filter(c => c.dispo || MOSTRAR_PROXIMOS).forEach((c, ci) => {
  const fila = document.createElement('div');
  fila.className = 'col-fila reveal' + (c.dispo ? ' dispo' : '');
  fila.style.transitionDelay = (ci*100)+'ms';
  const piezasHTML = c.piezas.map((p, i) => {
    const media = p.img
      ? `<img class="card-foto card-foto--front" src="${IMGS[p.img]}" loading="lazy" decoding="async" alt="${p.nombre}">`
        + (p.hover ? `<img class="card-foto card-foto--back" src="${IMGS[p.hover]}" loading="lazy" decoding="async" alt="${p.nombre} — espalda" aria-hidden="true">` : ``)
      : ``;
    // Producto real (si existe) → pastillas de talla que añaden al carrito
    const prod = (c.dispo && p.prod) ? PRODUCTS[p.prod] : null;
    const variants = prod && prod.variants ? prod.variants : null;
    const buyable = variants && variants.some(v => v.available);
    const href = prod && prod.handle ? `/products/${prod.handle}` : null;
    // Precio real desde Shopify cuando el producto existe; si no, el de la ficha estática (teasers)
    const precio = precioReal(p.prod, p.precio);
    const imgOpen = href ? `<a class="card-img" href="${href}" aria-label="Ver ${p.nombre}">` : `<div class="card-img">`;
    const imgClose = href ? `</a>` : `</div>`;
    let footHTML;
    if (buyable) {
      const single = variants.length === 1 && /default/i.test(variants[0].title);
      const imgUrl = p.img ? IMGS[p.img] : '';
      const data = `data-prod="${p.prod}" data-name="${p.nombre}" data-price="${precio}" data-img="${imgUrl}"${single ? ` data-vid="${variants[0].id}"` : ''}`;
      footHTML = `<span class="card-precio">${fmt(precio)}</span><button class="add-btn" ${data} aria-label="Añadir ${p.nombre}">Añadir</button>`;
    } else if (c.dispo) {
      footHTML = `<span class="card-precio">${fmt(precio)}</span><span class="card-precio sutil">Próximamente</span>`;
    } else {
      footHTML = `<span class="card-precio sutil">Lista de espera</span>`;
    }
    const nameHTML = href
      ? `<a class="card-name" href="${href}">${p.nombre}</a>`
      : `<h3 class="card-name">${p.nombre}</h3>`;
    return `
    <article class="card${c.dispo ? '' : ' proximo'}${p.hover ? ' card--swap' : ''}">
      ${imgOpen}
        ${media}
        <span class="card-num">0${i+1}</span>
        ${p.hover ? `<span class="card-flip">Frente · Espalda</span>` : ``}
        ${c.dispo ? `` : `<span class="card-lock">Próximamente</span>`}
      ${imgClose}
      <div class="card-body">
        <div class="card-meta">
          ${nameHTML}
          <p class="card-disc">${c.claim}</p>
        </div>
        <div class="card-foot">${footHTML}</div>
      </div>
    </article>`;
  }).join('');
  fila.innerHTML = `
    <div class="col-cab">
      <span class="drop-tag">${c.drop}</span>
      <h3>${c.nombre}</h3>
      <span class="claim-c">${c.claim}</span>
      <span class="estado-c">${c.estado}</span>
    </div>
    ${piezasHTML}`;
  filas.appendChild(fila);
  io.observe(fila);
});
}

/* ---------- CARRITO REAL · Shopify AJAX Cart API ---------- */
const drawer = document.getElementById('drawer');
const overlay = document.getElementById('overlay');
const cartCount = document.getElementById('cartCount');
const drawerItems = document.getElementById('drawerItems');
const cartTotal = document.getElementById('cartTotal');
const checkout = document.getElementById('checkout');
const drawerTrap = drawer ? makeTrap(drawer) : null;

function abrir(){
  if(drawer.classList.contains('open')){ overlay.classList.add('open'); return; }
  drawer.classList.add('open'); overlay.classList.add('open');
  drawer.setAttribute('aria-hidden','false');
  lockScroll(); if(drawerTrap) drawerTrap.engage();
}
function cerrar(){
  if(!drawer.classList.contains('open')) return;
  drawer.classList.remove('open'); overlay.classList.remove('open');
  drawer.setAttribute('aria-hidden','true');
  unlockScroll(); if(drawerTrap) drawerTrap.release();
}
const btnAbrir = document.getElementById('abrirCarrito');
if (btnAbrir) btnAbrir.addEventListener('click', ()=>{ refreshCart(); abrir(); });
document.getElementById('cerrarCarrito').addEventListener('click',cerrar);
overlay.addEventListener('click',cerrar);
document.addEventListener('keydown',e=>{if(e.key==='Escape' && drawer.classList.contains('open'))cerrar()});

function setCount(n, pop){
  cartCount.textContent = n;
  cartCount.classList.toggle('cc-zero', n === 0);
  if(pop){cartCount.classList.add('pop');setTimeout(()=>cartCount.classList.remove('pop'),260);}
}

/* ---------- BARRA DE ENVÍO GRATIS ---------- */
const shipBar = document.getElementById('shipBar');
const shipBarText = document.getElementById('shipBarText');
const shipBarFill = document.getElementById('shipBarFill');
const FREE_SHIP = (+window.AUREN_FREE_SHIP || 0) * 100; // en céntimos
function actualizarBarraEnvio(totalCents, itemCount){
  if(!shipBar) return;
  if(FREE_SHIP <= 0 || !itemCount){ shipBar.hidden = true; return; }
  shipBar.hidden = false;
  const pct = Math.min(100, Math.round(totalCents / FREE_SHIP * 100));
  shipBarFill.style.width = pct + '%';
  if(totalCents >= FREE_SHIP){
    shipBar.classList.add('is-free');
    shipBarText.innerHTML = '✓ ¡Tienes <strong>envío gratis</strong>!';
  } else {
    shipBar.classList.remove('is-free');
    shipBarText.innerHTML = 'Te faltan <strong>' + fmt((FREE_SHIP - totalCents)/100) + '</strong> para el envío gratis';
  }
}

/* Rombo dorado que vuela del botón pulsado al carrito (micro-feedback de añadido) */
const cartBtnNav = document.getElementById('abrirCarrito');
function flyToCart(fromEl){
  if(!motionOk || !fromEl || !cartBtnNav) return;
  const a = fromEl.getBoundingClientRect();
  if(!a.width) return; // el origen ya no está visible
  const b = cartBtnNav.getBoundingClientRect();
  const dot = document.createElement('span');
  dot.className = 'fly-dot';
  dot.style.left = (a.left + a.width/2) + 'px';
  dot.style.top  = (a.top + a.height/2) + 'px';
  document.body.appendChild(dot);
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    dot.style.transform = `translate(${b.left + b.width/2 - (a.left + a.width/2)}px, ${b.top + b.height/2 - (a.top + a.height/2)}px) rotate(45deg) scale(.25)`;
    dot.style.opacity = '0';
  }));
  setTimeout(()=>dot.remove(), 750);
}

/* Añadir una o varias variantes reales al carrito de Shopify */
async function addItems(items, btn){
  if(btn){ flyToCart(btn); btn.classList.add('loading'); btn.disabled = true; }
  try{
    const res = await fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items })
    });
    if(!res.ok) throw new Error('add.js ' + res.status);
    if(btn){ btn.classList.remove('loading'); btn.classList.add('ok'); setTimeout(()=>btn.classList.remove('ok'),1100); }
    await refreshCart(true);
    abrir();
    return true;
  }catch(err){
    console.error('AUREN cart:', err);
    toast('No se pudo añadir al carrito. Inténtalo de nuevo.');
    return false;
  }finally{ if(btn) btn.disabled = false; }
}
const addVariant = (variantId, btn) => addItems([{ id: variantId, quantity: 1 }], btn);

/* ---------- POPUP DE COMPRA RÁPIDA (selección de talla) ---------- */
const quickAdd = document.getElementById('quickAdd');
const qaddImg = document.getElementById('qaddImg');
const qaddName = document.getElementById('qaddName');
const qaddPrice = document.getElementById('qaddPrice');
const qaddSizes = document.getElementById('qaddSizes');
const quickAddTrap = quickAdd ? makeTrap(quickAdd) : null;

function abrirQuickAdd(prodKey, name, price, img){
  const prod = PRODUCTS[prodKey];
  if(!prod || !prod.variants) return;
  qaddName.textContent = name;
  qaddPrice.textContent = fmt(price);
  if(img){ qaddImg.src = img; qaddImg.style.display=''; } else { qaddImg.style.display='none'; }
  qaddSizes.innerHTML = prod.variants.map(v =>
    `<button class="size-btn" data-vid="${+v.id}" ${v.available ? '' : 'disabled'} aria-label="Talla ${esc(v.title)}">${esc(v.title)}</button>`
  ).join('');
  quickAdd.hidden = false; lockScroll(); if(quickAddTrap) quickAddTrap.engage();
}
function cerrarQuickAdd(){
  if(quickAdd && !quickAdd.hidden){ quickAdd.hidden = true; unlockScroll(); if(quickAddTrap) quickAddTrap.release(); }
}

/* Botón "Añadir" en las tarjetas → popup (o añade directo si variante única) */
if (filas) filas.addEventListener('click', e=>{
  const btn = e.target.closest('.add-btn'); if(!btn) return;
  if(btn.dataset.vid){ addVariant(+btn.dataset.vid, btn); return; }
  abrirQuickAdd(btn.dataset.prod, btn.dataset.name, +btn.dataset.price, btn.dataset.img);
});

if (quickAdd) {
  qaddSizes.addEventListener('click', e=>{
    const sb = e.target.closest('.size-btn'); if(!sb || sb.disabled) return;
    const vid = +sb.dataset.vid;
    flyToCart(sb); // antes de cerrar el modal, mientras la talla sigue visible
    cerrarQuickAdd();
    addVariant(vid, null);
  });
  quickAdd.addEventListener('click', e=>{ if(e.target.hasAttribute('data-qadd-close')) cerrarQuickAdd(); });
  document.addEventListener('keydown', e=>{ if(e.key==='Escape' && !quickAdd.hidden) cerrarQuickAdd(); });
}

/* ---------- CONJUNTO FOUNDATION (rashguard + shorts en un paso) ---------- */
const setModal = document.getElementById('setModal');
if (setModal) {
  const setSizesR = document.getElementById('setSizesR');
  const setSizesS = document.getElementById('setSizesS');
  const setAdd = document.getElementById('setAdd');
  const setPrice = document.getElementById('setPrice');
  const setTrap = makeTrap(setModal);
  let selR = null, selS = null;

  const pastillas = (container, prodKey) => {
    const prod = PRODUCTS[prodKey];
    container.innerHTML = (prod && prod.variants ? prod.variants : []).map(v =>
      `<button class="size-btn" data-vid="${+v.id}" ${v.available ? '' : 'disabled'} aria-label="Talla ${esc(v.title)}">${esc(v.title)}</button>`
    ).join('');
  };
  const refrescarSetBtn = ()=>{ setAdd.disabled = !(selR && selS); };
  const seleccionar = (container, btn, cual)=>{
    container.querySelectorAll('.size-btn').forEach(x=>x.classList.remove('sel'));
    btn.classList.add('sel');
    if(cual === 'r') selR = +btn.dataset.vid; else selS = +btn.dataset.vid;
    refrescarSetBtn();
  };

  function abrirSet(){
    // Sin productos publicados (pre-lanzamiento): llevamos al aviso de drop, nunca a un 404
    if(!PRODUCTS.rashguard || !PRODUCTS.shorts){
      toast('FOUNDATION llega muy pronto. Únete al círculo y sé el primero.');
      const news = document.getElementById('news');
      if(news) news.scrollIntoView({ behavior: motionOk ? 'smooth' : 'auto' });
      return;
    }
    selR = selS = null; refrescarSetBtn();
    pastillas(setSizesR, 'rashguard');
    pastillas(setSizesS, 'shorts');
    const total = precioReal('rashguard',49) + precioReal('shorts',39);
    if(setPrice) setPrice.textContent = fmt(total);
    setModal.hidden = false; lockScroll(); setTrap.engage();
  }
  function cerrarSet(){ if(!setModal.hidden){ setModal.hidden = true; unlockScroll(); setTrap.release(); } }

  setSizesR.addEventListener('click', e=>{ const b = e.target.closest('.size-btn'); if(b && !b.disabled) seleccionar(setSizesR, b, 'r'); });
  setSizesS.addEventListener('click', e=>{ const b = e.target.closest('.size-btn'); if(b && !b.disabled) seleccionar(setSizesS, b, 's'); });
  setAdd.addEventListener('click', async ()=>{
    if(!selR || !selS) return;
    const ok = await addItems([{ id: selR, quantity: 1 }, { id: selS, quantity: 1 }], setAdd);
    if(ok) cerrarSet();
  });
  setModal.addEventListener('click', e=>{ if(e.target.hasAttribute('data-set-close')) cerrarSet(); });
  document.addEventListener('keydown', e=>{ if(e.key==='Escape' && !setModal.hidden) cerrarSet(); });

  const btnConjunto = document.getElementById('addConjunto');
  if(btnConjunto) btnConjunto.addEventListener('click', abrirSet);
}

/* Cambios de cantidad / eliminar dentro del cajón */
drawerItems.addEventListener('click', async e=>{
  const el = e.target.closest('[data-key]'); if(!el) return;
  let qty = +el.dataset.qty;
  if(el.classList.contains('mas')) qty++;
  else if(el.classList.contains('menos')) qty--;
  else if(el.classList.contains('item-del')) qty = 0;
  else return;
  await fetch('/cart/change.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ id: el.dataset.key, quantity: Math.max(0, qty) })
  });
  await refreshCart();
});

/* Leer y pintar el carrito real */
async function refreshCart(pop){
  let cart;
  try{ cart = await (await fetch('/cart.js')).json(); }catch(e){ return; }
  setCount(cart.item_count, pop);
  actualizarBarraEnvio(cart.total_price, cart.item_count);
  if(!cart.items.length){
    drawerItems.innerHTML = '<p class="cart-empty">Tu carrito está vacío.</p>';
    cartTotal.textContent = fmt(0);
    checkout.disabled = true;
    return;
  }
  drawerItems.innerHTML = cart.items.map(it=>`
    <div class="item">
      <div class="item-thumb">${ it.image ? `<img src="${esc(it.image)}" alt="" loading="lazy">` : '' }</div>
      <div class="item-info">
        <h5>${esc(it.product_title)}</h5>
        ${ it.variant_title ? `<span class="item-var">Talla ${esc(it.variant_title)}</span>` : '' }
        <span class="p">${fmt(it.final_line_price/100)}</span>
        <div class="qty">
          <button class="menos" data-key="${it.key}" data-qty="${it.quantity}" aria-label="Quitar uno">−</button>
          <span>${it.quantity}</span>
          <button class="mas" data-key="${it.key}" data-qty="${it.quantity}" aria-label="Añadir uno">+</button>
        </div>
      </div>
      <button class="item-del" data-key="${it.key}" data-qty="${it.quantity}">Eliminar</button>
    </div>`).join('');
  cartTotal.textContent = fmt(cart.total_price/100);
  checkout.disabled = false;
}
refreshCart();

checkout.addEventListener('click',()=>{ window.location.href = '/checkout'; });

/* ---------- HERO: parallax con ratón ----------
   El wordmark NO se trocea en letras: background-clip:text no atraviesa
   spans inline-block (lo dejaba invisible). Se revela entero vía CSS. */
const octWrap = document.getElementById('octWrap');
/* El patrón de fondo deriva solo por CSS (transform en GPU); aquí únicamente
   se mueve el conjunto octágono+emblema con el ratón. */
if(octWrap && motionOk && matchMedia('(pointer:fine)').matches){
  document.getElementById('top').addEventListener('mousemove', e=>{
    const x = (e.clientX/innerWidth - .5), y = (e.clientY/innerHeight - .5);
    octWrap.style.transform = `translate(${x*16}px, ${y*16}px)`;
  });
}

/* ---------- MENÚ MÓVIL ---------- */
const navBurger = document.getElementById('navBurger');
const navMobile = document.getElementById('navMobile');
const navMobileClose = document.getElementById('navMobileClose');
const navTrap = navMobile ? makeTrap(navMobile) : null;
if (navBurger && navMobile) {
  const abrirMenu = ()=>{
    navMobile.classList.add('open'); document.body.classList.add('nav-open');
    navBurger.setAttribute('aria-expanded','true'); navMobile.setAttribute('aria-hidden','false');
    lockScroll(); if(navTrap) navTrap.engage();
  };
  const cerrarMenu = ()=>{
    navMobile.classList.remove('open'); document.body.classList.remove('nav-open');
    navBurger.setAttribute('aria-expanded','false'); navMobile.setAttribute('aria-hidden','true');
    unlockScroll(); if(navTrap) navTrap.release();
  };
  navBurger.addEventListener('click', ()=> navMobile.classList.contains('open') ? cerrarMenu() : abrirMenu());
  if (navMobileClose) navMobileClose.addEventListener('click', cerrarMenu);
  navMobile.querySelectorAll('a').forEach(a => a.addEventListener('click', cerrarMenu));
  document.addEventListener('keydown', e=>{ if(e.key==='Escape' && navMobile.classList.contains('open')) cerrarMenu(); });
}

/* ---------- DROP: revelado ---------- */
const dropFig = document.getElementById('dropFig');
const dropImg = document.getElementById('dropImg');
if (dropFig) {
const ioDrop = new IntersectionObserver(es=>{
  es.forEach(en=>{if(en.isIntersecting){dropFig.classList.add('in');ioDrop.disconnect()}});
},{threshold:.25});
ioDrop.observe(dropFig);
}

/* ---------- GALERÍA DEL HERO (modelo primero · flechas + puntos + swipe) ---------- */
const dropGallery = document.getElementById('dropGallery');
const DROP_IMGS = Array.isArray(window.AUREN_DROP_IMAGES) ? window.AUREN_DROP_IMAGES : [];
if (dropGallery && dropImg && DROP_IMGS.length > 1){
  let di = 0;
  const DROP_ALTS = [
    'Modelo AUREN con el equipo FOUNDATION, vista frontal',
    'Modelo AUREN con el equipo FOUNDATION, vista de espalda',
    'Detalle del cuello interior del rashguard FOUNDATION: Built to Dominate',
    'Shorts FOUNDATION Black'
  ];
  DROP_IMGS.forEach(src => { const im = new Image(); im.src = src; }); // precarga
  const dots = document.createElement('div'); dots.className = 'dg-dots';
  DROP_IMGS.forEach((_, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'dg-dot'; b.setAttribute('aria-label', 'Imagen ' + (i+1));
    b.addEventListener('click', () => irA(i));
    dots.appendChild(b);
  });
  const prev = document.createElement('button');
  prev.type = 'button'; prev.className = 'dg-arrow dg-prev'; prev.setAttribute('aria-label', 'Imagen anterior'); prev.textContent = '‹';
  const next = document.createElement('button');
  next.type = 'button'; next.className = 'dg-arrow dg-next'; next.setAttribute('aria-label', 'Imagen siguiente'); next.textContent = '›';
  prev.addEventListener('click', () => irA(di - 1));
  next.addEventListener('click', () => irA(di + 1));
  dropGallery.append(prev, next, dots);
  const DROP_SRCSETS = Array.isArray(window.AUREN_DROP_SRCSETS) ? window.AUREN_DROP_SRCSETS : [];
  const pintar = () => {
    dropImg.style.opacity = '0';
    const tmp = new Image();
    tmp.onload = () => {
      dropImg.srcset = DROP_SRCSETS[di] || '';
      dropImg.src = DROP_IMGS[di];
      if (DROP_ALTS[di]) dropImg.alt = DROP_ALTS[di];
      dropImg.style.opacity = '1';
    };
    tmp.src = DROP_IMGS[di];
    [...dots.children].forEach((d, i) => d.classList.toggle('on', i === di));
  };
  const irA = i => { di = (i + DROP_IMGS.length) % DROP_IMGS.length; pintar(); };
  dots.children[0].classList.add('on');
  // swipe táctil
  let x0 = null;
  dropGallery.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, {passive:true});
  dropGallery.addEventListener('touchend', e => {
    if(x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    if(Math.abs(dx) > 40) irA(dx < 0 ? di + 1 : di - 1);
    x0 = null;
  });
}

/* ---------- CARRUSEL DE DROPS (deslizar entre drops con flechas/puntos/swipe) ---------- */
const dcTrack = document.getElementById('dcTrack');
if (dcTrack) {
  const dcSlides = [...dcTrack.children];
  const dcPrev = document.querySelector('.dc-prev');
  const dcNext = document.querySelector('.dc-next');
  const dcDots = document.getElementById('dcDots');
  let dcIdx = 0;
  if (dcDots) dcSlides.forEach((_, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'dc-dot'; b.setAttribute('aria-label', 'Drop ' + (i + 1));
    b.addEventListener('click', () => dcGo(i));
    dcDots.appendChild(b);
  });
  const dcRender = () => {
    dcTrack.style.transform = `translateX(${-dcIdx * 100}%)`;
    if (dcDots) [...dcDots.children].forEach((d, i) => d.classList.toggle('on', i === dcIdx));
    if (dcPrev) dcPrev.disabled = dcIdx === 0;
    if (dcNext) dcNext.disabled = dcIdx === dcSlides.length - 1;
    dcSlides.forEach((s, i) => {
      s.setAttribute('aria-hidden', i !== dcIdx);
      s.inert = i !== dcIdx; // los slides ocultos no reciben foco ni clicks
    });
  };
  const dcGo = i => { dcIdx = Math.max(0, Math.min(dcSlides.length - 1, i)); dcRender(); };
  if (dcPrev) dcPrev.addEventListener('click', () => dcGo(dcIdx - 1));
  if (dcNext) dcNext.addEventListener('click', () => dcGo(dcIdx + 1));
  dcRender();
  /* swipe entre drops — pero un swipe SOBRE la foto lo gestiona la galería de imágenes */
  let dcx0 = null;
  dcTrack.addEventListener('touchstart', e => {
    if (e.target.closest('.drop-img-wrap')) { dcx0 = null; return; }
    dcx0 = e.touches[0].clientX;
  }, {passive:true});
  dcTrack.addEventListener('touchend', e => {
    if (dcx0 === null) return;
    const dx = e.changedTouches[0].clientX - dcx0;
    if (Math.abs(dx) > 50) dcGo(dcIdx + (dx < 0 ? 1 : -1));
    dcx0 = null;
  });
}

/* ---------- SCROLL-SPY: subraya en el nav la sección visible ---------- */
const spyLinks = [...document.querySelectorAll('.nav-links a[href^="#"]')];
if (spyLinks.length) {
  const clearSpy = () => spyLinks.forEach(a => a.classList.remove('active'));
  const spyIO = new IntersectionObserver(es => {
    es.forEach(en => {
      if (!en.isIntersecting) return;
      if (en.target.id === 'top') { clearSpy(); return; } // en el hero, nada activo
      const link = spyLinks.find(a => a.getAttribute('href') === '#' + en.target.id);
      if (link) { clearSpy(); link.classList.add('active'); }
    });
  }, { rootMargin: '-40% 0px -55% 0px' });
  const hero = document.getElementById('top');
  if (hero) spyIO.observe(hero);
  spyLinks.forEach(a => {
    const t = document.getElementById(a.getAttribute('href').slice(1));
    if (t) spyIO.observe(t);
  });
}

/* ---------- SCROLL: nav sólido + parallax del drop (un solo listener) ---------- */
const nav = document.getElementById('nav');
let scrollTicking = false;
addEventListener('scroll',()=>{
  if(scrollTicking) return; scrollTicking = true;
  requestAnimationFrame(()=>{
    if(nav) nav.classList.toggle('solid', scrollY > 40);
    if(motionOk && dropFig && dropImg){
      const r = dropFig.getBoundingClientRect();
      if(r.bottom > 0 && r.top < innerHeight){
        const prog = (r.top + r.height/2 - innerHeight/2) / innerHeight;
        dropImg.style.transform = `scale(1.04) translateY(${prog * -12}px)`;
      }
    }
    scrollTicking = false;
  });
},{passive:true});

/* ---------- NEWSLETTER ---------- */
/* Newsletter: en Shopify el form 'customer' hace POST real y el mensaje de éxito
   lo pinta Liquid (form.posted_successfully?). Este handler solo actúa en la demo
   standalone, donde el form no tiene action de Shopify. */
/* ---------- GUÍA DE TALLAS (modal de la home; se abre desde quick-add y conjunto) ---------- */
const sgModal = document.getElementById('sgModal');
if (sgModal) {
  const sgTrap = makeTrap(sgModal);
  const abrirSg = ()=>{ if(sgModal.hidden){ sgModal.hidden = false; lockScroll(); sgTrap.engage(); } };
  const cerrarSg = ()=>{ if(!sgModal.hidden){ sgModal.hidden = true; unlockScroll(); sgTrap.release(); } };
  document.querySelectorAll('[data-open-sg]').forEach(b => b.addEventListener('click', abrirSg));
  sgModal.addEventListener('click', e=>{ if(e.target.hasAttribute('data-sg-close')) cerrarSg(); });
  document.addEventListener('keydown', e=>{ if(e.key==='Escape' && !sgModal.hidden){ e.stopPropagation(); cerrarSg(); } }, true);
}

const newsForm = document.getElementById('newsForm');
if (newsForm && !newsForm.action) {
  newsForm.addEventListener('submit', e => {
    e.preventDefault();
    const msg = document.getElementById('newsMsg');
    if (msg) msg.textContent = 'Bienvenido al círculo. Te avisaremos antes que a nadie.';
    e.target.reset();
  });
}
